
import { defineComponent, onMounted, ref } from "vue";
import { IonPage, IonContent, IonItem, IonSkeletonText, isPlatform } from "@ionic/vue";
import TradeRepository from "@/repositories/TradeRepository";
import TradeChart from "@/components/TradeChart.vue";
import TradeTable from "@/components/TradeTable.vue";
import TradeSelect from "@/components/TradeSelect.vue";
import TradePopover from "@/components/TradePopover.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    IonPage,
    IonContent,
    IonItem,
    TradeChart,
    TradeTable,
    TradeSelect,
    TradePopover,
    IonSkeletonText,
  },

  setup() {
    const route = useRoute();

    const loading = ref(false);

    const isMobile = (): boolean => {
      if (process.env.NODE_ENV !== "production") {
        return isPlatform("mobile");
      }
      return route.query.mobile == "yes" ? true : false;
    };

    const getTrades = async (): Promise<void> => {
      loading.value = true;
      await TradeRepository.getTrades();
      loading.value = false;
    };

    onMounted(() => {
      TradeRepository.setType(route.params.type as string);
      getTrades();
    });

    return {
      loading,
      isMobile,
    };
  },
});
